import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import styles from "./VariableTextField.module.scss";

interface VariableTextChipProps extends ComponentPropsWithoutRef<"span"> {
    label: string;
}

export const VariableTextChip = ({
    label,
    className,
    children,
    ...props
}: VariableTextChipProps) => (
    <span {...props} className={classNames(styles.variable, className)}>
        <Tooltip content={`${label} fills in automatically for each entity`}>
            <span>{label}</span>
        </Tooltip>
        {children}
    </span>
);
